
import Vue from "vue";
import bingoStorage from "../models/BingoStorage";
import Roulette from "../components/Roulette.vue";
import OpenNumbers from "../components/OpenNumbers.vue";
import BingoWS from "../api/BingoWS";
import { IBingo, IBingoMember, IBingoAndMember } from "../@types/interface.d";

interface IData {
  notFound: boolean;
  bingo: IBingo | undefined;
  member: IBingoMember | undefined;
  api: BingoWS | undefined;
  nextNumber: number;
}

export default Vue.extend({
  name: "bingo",
  components: {
    Roulette,
    OpenNumbers,
  },
  data(): IData {
    return {
      notFound: false,
      bingo: undefined,
      member: undefined,
      api: undefined,
      nextNumber: 0,
    };
  },
  created() {
    const { bingoId } = this.$route.params;
    const bingoData = bingoStorage.getBingoData(bingoId);
    const endpoint = bingoData ? `/api/bingo/${bingoId}/${bingoData.memberId}` : `/api/bingo/${bingoId}`;
    fetch(endpoint).then(v => v.json()).then((v) => {
      const data = v as IBingoAndMember;
      this.bingo = data.bingo;
      this.member = data.member;
      new BingoWS(location.host).open().then((ws) => {
        this.api = ws;
        this.api.ping();
      });
    }).catch(() => {
      this.notFound = true;
    });
  },
  computed: {
    num(): number {
      if (this.nextNumber) {
        return this.nextNumber;
      }
      const nums = this.bingo?.openNumbers || [];
      return nums[nums.length - 1] || 0;
    },
  },
  methods: {
    runRoulette(): void {
      this.nextNumber = this.calcNext();
    },
    calcNext(): number {
      const n = Math.floor((Math.random() * 75) + 1);
      return this.bingo?.openNumbers.indexOf(n) !== -1 ? this.calcNext() : n;
    },
    onFix(n: number): void {
      this.bingo?.openNumbers.push(n);
    },
  },
});
